import React, { useEffect, useState } from "react";
import axios from "axios";
import defaultUserImg from "../../../assets/images/defaultuserimgdark.png";
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  Label,
  Button,
  Form,
  Input,
  FormFeedback,
  InputGroup,
  InputGroupText,
  Alert,
  Modal, ModalHeader,
} from "reactstrap";
import { useFormik } from "formik";
import { Link } from 'react-router-dom';
import { Users } from 'lucide-react';

const baseUrl = process.env.REACT_APP_BASE_URL;

const validateEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
const validatePhone = (phone: string) => /^\+?[0-9]{10,15}$/.test(phone);
const validateURL = (url: string) => {
  if (!url) return true; // Allow empty
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

// Helper function to handle phone input (numbers only, max 10)
const handlePhoneChange = (value: string, setter: (val: string) => void) => {
  const numbersOnly = value.replace(/\D/g, '');
  if (numbersOnly.length <= 10) {
    setter(numbersOnly);
  }
};

const validate = (values: any) => {
  const errors: any = {};
  // Required personal info fields
  if (!values.firstname) errors.firstname = "First name is required";
  if (!values.lastname) errors.lastname = "Last name is required";
  if (!values.email) errors.email = "Email is required";
  else if (!validateEmail(values.email)) errors.email = "Invalid email format";
  if (!values.phone) errors.phone = "Phone number is required";
  else if (!validatePhone(values.phone)) errors.phone = "Enter a valid phone number";
  
  // Company info validations (only if value is provided)
  // URL validations
  if (values.website && !validateURL(values.website)) {
    errors.website = "Please enter a valid website URL";
  }
  if (values.linkedin_url && !validateURL(values.linkedin_url)) {
    errors.linkedin_url = "Please enter a valid LinkedIn URL";
  }
  if (values.facebook_url && !validateURL(values.facebook_url)) {
    errors.facebook_url = "Please enter a valid Facebook URL";
  }
  if (values.x_url && !validateURL(values.x_url)) {
    errors.x_url = "Please enter a valid X (Twitter) URL";
  }
  if (values.instagram_url && !validateURL(values.instagram_url)) {
    errors.instagram_url = "Please enter a valid Instagram URL";
  }
  if (values.youtube_url && !validateURL(values.youtube_url)) {
    errors.youtube_url = "Please enter a valid YouTube URL";
  }
  
  // Numeric validations
  if (values.years_in_business) {
    const years = parseInt(values.years_in_business);
    if (isNaN(years) || years < 0) {
      errors.years_in_business = "Years in business must be a valid positive number";
    }
  }
  if (values.number_of_employees) {
    const employees = parseInt(values.number_of_employees);
    if (isNaN(employees) || employees < 0) {
      errors.number_of_employees = "Number of employees must be a valid positive number";
    }
  }
  
  return errors;
};

interface FormValues {
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  image: string | File;
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
  // Company Information
  company_name: string;
  company_description: string;
  industry: string;
  years_in_business: string;
  number_of_employees: string;
  company_size: string;
  service_areas: string;
  specializations: string;
  // Address
  address_line1: string;
  address_line2: string;
  city: string;
  state: string;
  zipcode: string;
  country: string;
  // Website and Social Media
  website: string;
  linkedin_url: string;
  facebook_url: string;
  x_url: string;
  instagram_url: string;
  youtube_url: string;
}

interface CommunicationPreferenceValues {
  // Before Purchase
  bef_pur_email: string;
  bef_pur_email_enabled: boolean;
  bef_pur_phone: string;
  bef_pur_phone_enabled: boolean;
  bef_pur_notes: string;
  bef_pur_calendly: string;
  bef_pur_calendly_enabled: boolean;
  bef_pur_zoom: string;
  bef_pur_zoom_enabled: boolean;
  bef_pur_teams: string;
  bef_pur_teams_enabled: boolean;
  bef_pur_whatsapp: string;
  bef_pur_whatsapp_enabled: boolean;
  bef_pur_others: string;
  bef_pur_others_enabled: boolean;
  // After Purchase
  aft_pur_email: string;
  aft_pur_email_enabled: boolean;
  aft_pur_phone: string;
  aft_pur_phone_enabled: boolean;
  aft_pur_notes: string;
  aft_pur_calendly: string;
  aft_pur_calendly_enabled: boolean;
  aft_pur_zoom: string;
  aft_pur_zoom_enabled: boolean;
  aft_pur_teams: string;
  aft_pur_teams_enabled: boolean;
  aft_pur_whatsapp: string;
  aft_pur_whatsapp_enabled: boolean;
  aft_pur_others: string;
  aft_pur_others_enabled: boolean;
}

const PrtProfile = () => {
  document.title = "Partner Profile | BizServe";
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [alertMsgg, setAlertMsgg] = useState<any>({open:false, type:"success", content:'Messages here.', time:'2500'});
  const handleAlertMsggClose = ( event?: React.SyntheticEvent | Event, reason?: string) => {  
      if (reason === "clickaway") { return; }
      setAlertMsgg({ ...alertMsgg, open: false })
  };

  const [showloader, setshowloader] = useState(true);
  const is_two_fact_status = JSON.parse(localStorage.getItem('enable_two_fact') || 'false')
  const [qrImage, setqrImage] = useState<string | null>(null);
  const [otp, setotp] = useState("");
  const [step, setStep] = useState(0);
  const [recoverykey, setrecoverykey] = useState<string[]>([]);
  const [modal_center, setmodal_center] = useState(false);
  const [disableotp, setdisableotp] = useState("");
  const [secretkey, setsecretkey] = useState("");

  const toggletwofactauth = async() => {
    try{
      setshowloader(true);
      const user_email = JSON.parse(localStorage.getItem('userdata') || '{}').email
      const formdata = new FormData();
      formdata.append("email", user_email)
      const response = await axios.post(`/accounts/two_factor_auth`,formdata,
        {headers :{'Content-Type': 'multipart/form-data'}});
        if(response.status === 'UPDATED'){
          const qr = response.qr_code
          setqrImage(qr)
          setStep(1)
          const sec = response.secret
          setsecretkey(sec)
          setshowloader(false);
        }
    }catch (error:any) {
        if (error.response) {
            if ([401, 422].includes(error.response.status)) {
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 3000);
            }
            else if (error.response.status === 403) {
                setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                setTimeout(()=>{window.location.href="/logout"}, 2000)
            } else {
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 2000);
            }
        } else {
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 2000);
        }
        setshowloader(false)
    }
  }

  const handleotpchnage = (e) => {
    setotp(e.target.value)
  }
  const verify_two_fact = async() => {
    try{
      if(!otp){
            setAlertMsgg({open:true, content : "Please enter the OTP.", type : "error"})
          setTimeout(() => {
            setAlertMsgg((prev) => ({...prev, open:false}));
          },3000)
          return;
        }
      setshowloader(true)
      const user_email = JSON.parse(localStorage.getItem('userdata') || '{}').email
      const formData = new FormData();
      formData.append("email", user_email)
      formData.append("otp",otp)
      const response = await axios.post(`accounts/two_factor_verify`,formData,
        {headers :{'Content-Type': 'multipart/form-data'}});
        if(response.status === "VERIFY"){
          const recover = response.recovery_codes
          setrecoverykey(recover);
          localStorage.setItem("enable_two_fact",JSON.stringify(response.enable_two_fact))
          setStep(2);
          setshowloader(false)
          setAlertMsgg({open:true, content : "Two-Factor Authentication Updated Successfully", type : "success"})
          setTimeout(() => {
            setAlertMsgg((prev) => ({...prev, open:false}));
          },3000)
        }
    }catch (error:any) {
        if (error.response) {
            if ([401, 422].includes(error.response.status)) {
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 3000);
            }
            else if (error.response.status === 403) {
                setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                setTimeout(()=>{window.location.href="/logout"}, 2000)
            } else {
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 2000);
            }
        } else {
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 2000);
        }
        setshowloader(false)
    }
  }

  const disableotpchnage = (e) => {
      setdisableotp(e.target.value)
    }

  const verify_disable_otp = async() =>{
    try{
        if(!disableotp){
            setAlertMsgg({open:true, content : "Please enter the OTP.", type : "error"})
          setTimeout(() => {
            setAlertMsgg((prev) => ({...prev, open:false}));
          },3000)
          return;
        }
        setshowloader(true);
        const user_email = JSON.parse(localStorage.getItem('userdata') || '{}').email
        const formdata = new FormData();
        formdata.append("email",user_email);
        formdata.append("otp",disableotp);
        const response = await axios.post(`/accounts/disable_two_factor`,formdata,
        {'headers': {'Content-Type' : 'multipart/form-data'}});
        if(response.status === "Deactive"){
            localStorage.removeItem("enable_two_fact");
            setshowloader(false);
            setAlertMsgg({open:true, content : "Two-Factor Authentication Updated Successfully", type : "success"})
            setTimeout(() =>{
            setAlertMsgg((prev) => ({...prev, open:false}));
            },3000)
            window.location.reload()
        }
    }catch (error:any) {
        if (error.response) {
            if ([401, 422].includes(error.response.status)) {
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 3000);
            }
            else if (error.response.status === 403) {
                setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                setTimeout(()=>{window.location.href="/logout"}, 2000)
            } else {
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 2000);
            }
        } else {
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            setTimeout(() => {setAlertMsgg(prev => ({ ...prev, open: false }));
                }, 2000);
        }
        setshowloader(false)
    }
  }

  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const [stripeConnectStatus, setStripeConnectStatus] = useState<any>(null);
  const [isLoadingStripeLink, setIsLoadingStripeLink] = useState(false);
  const [purchaseAgreements, setPurchaseAgreements] = useState<any[]>([]);
  const [isLoadingAgreements, setIsLoadingAgreements] = useState(false);
  const [uploadFile, setUploadFile] = useState<File | null>(null);
  const [isOptional, setIsOptional] = useState(false);
  const [commPrefs, setCommPrefs] = useState<CommunicationPreferenceValues>({
    bef_pur_email: "",
    bef_pur_email_enabled: false,
    bef_pur_phone: "",
    bef_pur_phone_enabled: false,
    bef_pur_notes: "",
    bef_pur_calendly: "",
    bef_pur_calendly_enabled: false,
    bef_pur_zoom: "",
    bef_pur_zoom_enabled: false,
    bef_pur_teams: "",
    bef_pur_teams_enabled: false,
    bef_pur_whatsapp: "",
    bef_pur_whatsapp_enabled: false,
    bef_pur_others: "",
    bef_pur_others_enabled: false,
    aft_pur_email: "",
    aft_pur_email_enabled: false,
    aft_pur_phone: "",
    aft_pur_phone_enabled: false,
    aft_pur_notes: "",
    aft_pur_calendly: "",
    aft_pur_calendly_enabled: false,
    aft_pur_zoom: "",
    aft_pur_zoom_enabled: false,
    aft_pur_teams: "",
    aft_pur_teams_enabled: false,
    aft_pur_whatsapp: "",
    aft_pur_whatsapp_enabled: false,
    aft_pur_others: "",
    aft_pur_others_enabled: false,
  });

  const formik = useFormik<FormValues>({
    initialValues: {
      firstname: "",
      lastname: "",
      email: "",
      phone: "",
      image: "",
      currentPassword:"",
      newPassword:"",
      confirmPassword:"",
      // Company Information
      company_name: "",
      company_description: "",
      industry: "",
      years_in_business: "",
      number_of_employees: "",
      company_size: "",
      service_areas: "",
      specializations: "",
      // Address
      address_line1: "",
      address_line2: "",
      city: "",
      state: "",
      zipcode: "",
      country: "",
      // Website and Social Media
      website: "",
      linkedin_url: "",
      facebook_url: "",
      x_url: "",
      instagram_url: "",
      youtube_url: "",
    },
    validate,
    onSubmit: async (values) => {
      const { firstname, lastname, email, phone, image } = values;

      if (!firstname || !lastname || !email || !phone) {
        setAlertMsgg({ open: true, content: "Please fill all required fields", type: "error" });
        return;
      }

      // Validate company info fields if provided
      const companyErrors: string[] = [];
      if (values.website && !validateURL(values.website)) {
        companyErrors.push("Website URL is invalid");
      }
      if (values.linkedin_url && !validateURL(values.linkedin_url)) {
        companyErrors.push("LinkedIn URL is invalid");
      }
      if (values.facebook_url && !validateURL(values.facebook_url)) {
        companyErrors.push("Facebook URL is invalid");
      }
      if (values.x_url && !validateURL(values.x_url)) {
        companyErrors.push("X (Twitter) URL is invalid");
      }
      if (values.instagram_url && !validateURL(values.instagram_url)) {
        companyErrors.push("Instagram URL is invalid");
      }
      if (values.youtube_url && !validateURL(values.youtube_url)) {
        companyErrors.push("YouTube URL is invalid");
      }
      if (values.years_in_business) {
        const years = parseInt(values.years_in_business);
        if (isNaN(years) || years < 0) {
          companyErrors.push("Years in business must be a valid positive number");
        }
      }
      if (values.number_of_employees) {
        const employees = parseInt(values.number_of_employees);
        if (isNaN(employees) || employees < 0) {
          companyErrors.push("Number of employees must be a valid positive number");
        }
      }

      if (companyErrors.length > 0) {
        setAlertMsgg({ open: true, content: companyErrors.join(". "), type: "error" });
        return;
      }

      const data = new FormData();
      data.append("first_name", firstname);
      data.append("last_name", lastname);
      data.append("email", email);
      data.append("phone", phone);

      // Company Information
      if (values.company_name) data.append("company_name", values.company_name);
      if (values.company_description) data.append("company_description", values.company_description);
      if (values.industry) data.append("industry", values.industry);
      if (values.years_in_business) data.append("years_in_business", values.years_in_business);
      if (values.number_of_employees) data.append("number_of_employees", values.number_of_employees);
      if (values.company_size) data.append("company_size", values.company_size);
      if (values.service_areas) data.append("service_areas", values.service_areas);
      if (values.specializations) data.append("specializations", values.specializations);

      // Address
      if (values.address_line1) data.append("address_line1", values.address_line1);
      if (values.address_line2) data.append("address_line2", values.address_line2);
      if (values.city) data.append("city", values.city);
      if (values.state) data.append("state", values.state);
      if (values.zipcode) data.append("zipcode", values.zipcode);
      if (values.country) data.append("country", values.country);

      // Website and Social Media
      if (values.website) data.append("website", values.website);
      if (values.linkedin_url) data.append("linkedin_url", values.linkedin_url);
      if (values.facebook_url) data.append("facebook_url", values.facebook_url);
      if (values.x_url) data.append("x_url", values.x_url);
      if (values.instagram_url) data.append("instagram_url", values.instagram_url);
      if (values.youtube_url) data.append("youtube_url", values.youtube_url);

      if (image instanceof File) {
        data.append("profile_pic", image);
      }

      try {
        setshowloader(true)
        // TODO: Create partner_profileupdate endpoint in backend
        const res = await axios.post(`/accounts/partner_profileupdate`, data,{
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        if (res.status === 'DONE') {
          setAlertMsgg({ open: true, content: "Profile updated Successfully!", type: "success" });
          setshowloader(false)
          setTimeout(() => {
            setAlertMsgg((prev) => ({ ...prev, open: false }));
          }, 4000);
          localStorage.setItem("userdata", JSON.stringify(res.user));
          window.dispatchEvent(new Event("refreshProfile"));
          fetchPartnerProfile();
        } else if (res.status === "ierror") {
          setAlertMsgg({ open: true, content: "User already exists!", type: "error" });
          setshowloader(false)
        }
      } catch (error:any) {
        if (error.response) {
            if ([401, 422].includes(error.response.status)) {
              setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
            }
            else if (error.response.status === 403) {
                setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                setTimeout(()=>{window.location.href="/logout"}, 2000)
            } else {
              setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
            }
        } else {
          setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
        }
        setshowloader(false)
    }
    },
  });

  const handlePasswordUpdate = async () => {
    formik.setErrors({});
    const errors: any = {};
    
    const { currentPassword, newPassword, confirmPassword } = formik.values;
    if (!currentPassword) errors.currentPassword = "Current password is required";
    if (!newPassword) errors.newPassword = "New password is required";
    if (!confirmPassword) errors.confirmPassword = "Confirm password is required";
    if (currentPassword && newPassword && currentPassword === newPassword) {
      errors.newPassword = "New password cannot be same as current password";
    }
    if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      errors.confirmPassword = "New and confirm passwords do not match";
    }
  
    const passwordPattern =
      /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{6,}$/;
    if (newPassword && !passwordPattern.test(newPassword)) {
      errors.newPassword =
        "Password must contain at least 6 characters, one uppercase letter, one number, and one special symbol";
    }

    if (Object.keys(errors).length > 0) {
      formik.setErrors(errors);
      return;
    }
    const data = new FormData();
    data.append("current_password", currentPassword);
    data.append("new_password", newPassword);
    data.append("confirm_Password", confirmPassword);
    data.append("access_token", localStorage.getItem("access_token") || "");
    try {
      setshowloader(true);
      const response = await axios.post("/accounts/change_password", data, {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
      });
      if (response.status === "success") {
        setAlertMsgg({ ...alertMsgg, open: true, content:"Password updated Sucessfully!", type:"success" });
        setshowloader(false);
        setTimeout(() => {
          setAlertMsgg(prev => ({ ...prev, open: false }));
        }, 4000);
        formik.resetForm();
      }
    } catch (error: any) {
      if (error.response) {
        if ([401, 422].includes(error.response.status)) {
          setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
        } else if (error.response.status === 403) {
          setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
          setTimeout(() => (window.location.href = "/logout"), 2000);
        } else {
          setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
        }
      } else {
        setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
      }
      setshowloader(false);
    }
  };

  const handleProfilePicChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      formik.setFieldValue("image", file);
      const reader = new FileReader();
      reader.onloadend = (event) => {
        if (typeof event.target?.result === "string") {
          setPreviewImage(event.target.result);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const fetchPartnerProfile = async () => {
    try {
      setshowloader(true)
      const response = await axios.get(`/accounts/get_partner_settings`,{});
      if (response.status === "SENT") {
        setshowloader(false)
        const userData = response.partner.user;
        const partnerData = response.partner;
        formik.setValues({
          firstname: userData.first_name || "",
          lastname: userData.last_name || "",
          email: userData.email || "",
          phone: userData.phone || "",
          image: userData.profile_pic || "",
          currentPassword:"",
          newPassword:"",
          confirmPassword:"",
          // Company Information
          company_name: partnerData.company_name || "",
          company_description: partnerData.company_description || "",
          industry: partnerData.industry || "",
          years_in_business: partnerData.years_in_business || "",
          number_of_employees: partnerData.number_of_employees || "",
          company_size: partnerData.company_size || "",
          service_areas: partnerData.service_areas || "",
          specializations: partnerData.specializations || "",
          // Address
          address_line1: partnerData.address_line1 || "",
          address_line2: partnerData.address_line2 || "",
          city: partnerData.city || "",
          state: partnerData.state || "",
          zipcode: partnerData.zipcode || "",
          country: partnerData.country || "",
          // Website and Social Media
          website: partnerData.website || "",
          linkedin_url: partnerData.linkedin_url || "",
          facebook_url: partnerData.facebook_url || "",
          x_url: partnerData.x_url || "",
          instagram_url: partnerData.instagram_url || "",
          youtube_url: partnerData.youtube_url || "",
        });
        // Set Stripe Connect status
        if (response.partner.stripe_connect) {
          setStripeConnectStatus(response.partner.stripe_connect);
        }
        // Set Communication Preferences
        let updatedCommPrefs: CommunicationPreferenceValues = {
          bef_pur_email: "",
          bef_pur_email_enabled: false,
          bef_pur_phone: "",
          bef_pur_phone_enabled: false,
          bef_pur_notes: "",
          bef_pur_calendly: "",
          bef_pur_calendly_enabled: false,
          bef_pur_zoom: "",
          bef_pur_zoom_enabled: false,
          bef_pur_teams: "",
          bef_pur_teams_enabled: false,
          bef_pur_whatsapp: "",
          bef_pur_whatsapp_enabled: false,
          bef_pur_others: "",
          bef_pur_others_enabled: false,
          aft_pur_email: "",
          aft_pur_email_enabled: false,
          aft_pur_phone: "",
          aft_pur_phone_enabled: false,
          aft_pur_notes: "",
          aft_pur_calendly: "",
          aft_pur_calendly_enabled: false,
          aft_pur_zoom: "",
          aft_pur_zoom_enabled: false,
          aft_pur_teams: "",
          aft_pur_teams_enabled: false,
          aft_pur_whatsapp: "",
          aft_pur_whatsapp_enabled: false,
          aft_pur_others: "",
          aft_pur_others_enabled: false,
        };

        if (response.partner.communication_preference) {
          const commPref = response.partner.communication_preference;
          updatedCommPrefs = {
            bef_pur_email: commPref.bef_pur_email || "",
            bef_pur_email_enabled: commPref.bef_pur_email_enabled || false,
            bef_pur_phone: commPref.bef_pur_phone || "",
            bef_pur_phone_enabled: commPref.bef_pur_phone_enabled || false,
            bef_pur_notes: commPref.bef_pur_notes || "",
            bef_pur_calendly: commPref.bef_pur_calendly || "",
            bef_pur_calendly_enabled: commPref.bef_pur_calendly_enabled || false,
            bef_pur_zoom: commPref.bef_pur_zoom || "",
            bef_pur_zoom_enabled: commPref.bef_pur_zoom_enabled || false,
            bef_pur_teams: commPref.bef_pur_teams || "",
            bef_pur_teams_enabled: commPref.bef_pur_teams_enabled || false,
            bef_pur_whatsapp: commPref.bef_pur_whatsapp || "",
            bef_pur_whatsapp_enabled: commPref.bef_pur_whatsapp_enabled || false,
            bef_pur_others: commPref.bef_pur_others || "",
            bef_pur_others_enabled: commPref.bef_pur_others_enabled || false,
            aft_pur_email: commPref.aft_pur_email || "",
            aft_pur_email_enabled: commPref.aft_pur_email_enabled || false,
            aft_pur_phone: commPref.aft_pur_phone || "",
            aft_pur_phone_enabled: commPref.aft_pur_phone_enabled || false,
            aft_pur_notes: commPref.aft_pur_notes || "",
            aft_pur_calendly: commPref.aft_pur_calendly || "",
            aft_pur_calendly_enabled: commPref.aft_pur_calendly_enabled || false,
            aft_pur_zoom: commPref.aft_pur_zoom || "",
            aft_pur_zoom_enabled: commPref.aft_pur_zoom_enabled || false,
            aft_pur_teams: commPref.aft_pur_teams || "",
            aft_pur_teams_enabled: commPref.aft_pur_teams_enabled || false,
            aft_pur_whatsapp: commPref.aft_pur_whatsapp || "",
            aft_pur_whatsapp_enabled: commPref.aft_pur_whatsapp_enabled || false,
            aft_pur_others: commPref.aft_pur_others || "",
            aft_pur_others_enabled: commPref.aft_pur_others_enabled || false,
          };
        }

        // Check if any before purchase preference is enabled
        const hasBefPurEnabled = updatedCommPrefs.bef_pur_email_enabled || 
          updatedCommPrefs.bef_pur_phone_enabled || 
          updatedCommPrefs.bef_pur_calendly_enabled || 
          updatedCommPrefs.bef_pur_zoom_enabled || 
          updatedCommPrefs.bef_pur_teams_enabled || 
          updatedCommPrefs.bef_pur_whatsapp_enabled || 
          updatedCommPrefs.bef_pur_others_enabled;

        // Check if any after purchase preference is enabled
        const hasAftPurEnabled = updatedCommPrefs.aft_pur_email_enabled || 
          updatedCommPrefs.aft_pur_phone_enabled || 
          updatedCommPrefs.aft_pur_calendly_enabled || 
          updatedCommPrefs.aft_pur_zoom_enabled || 
          updatedCommPrefs.aft_pur_teams_enabled || 
          updatedCommPrefs.aft_pur_whatsapp_enabled || 
          updatedCommPrefs.aft_pur_others_enabled;

        // Auto-enable email if no preference is enabled
        if (!hasBefPurEnabled) {
          updatedCommPrefs.bef_pur_email = userData.email || "";
          updatedCommPrefs.bef_pur_email_enabled = true;
        }
        if (!hasAftPurEnabled) {
          updatedCommPrefs.aft_pur_email = userData.email || "";
          updatedCommPrefs.aft_pur_email_enabled = true;
        }

        setCommPrefs(updatedCommPrefs);

        // If we auto-enabled email, save it to backend
        if (!hasBefPurEnabled || !hasAftPurEnabled) {
          setTimeout(async () => {
            try {
              const response = await axios.post(`/accounts/partner_communication_preferences`, updatedCommPrefs);
              if (response.status === "DONE") {
                // Silently updated
                console.log("Auto-enabled email communication preferences");
              }
            } catch (error:any) {
              console.error("Error auto-enabling email preferences:", error);
            }
          }, 500);
        }
      }
    } catch (error:any) {
      if (error.response) {
          if ([401, 422].includes(error.response.status)) {
            setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
          }
          else if (error.response.status === 403) {
              setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
              setTimeout(()=>{window.location.href="/logout"}, 2000)
          } else {
            setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
          }
      } else {
        setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
      }
      setshowloader(false)
  }
  };

  const handleCommPrefUpdate = async (silent: boolean = false) => {
    // Validate that at least one preference is enabled in both sections
    const hasBefPurEnabled = commPrefs.bef_pur_email_enabled || 
      commPrefs.bef_pur_phone_enabled || 
      commPrefs.bef_pur_calendly_enabled || 
      commPrefs.bef_pur_zoom_enabled || 
      commPrefs.bef_pur_teams_enabled || 
      commPrefs.bef_pur_whatsapp_enabled || 
      commPrefs.bef_pur_others_enabled;

    const hasAftPurEnabled = commPrefs.aft_pur_email_enabled || 
      commPrefs.aft_pur_phone_enabled || 
      commPrefs.aft_pur_calendly_enabled || 
      commPrefs.aft_pur_zoom_enabled || 
      commPrefs.aft_pur_teams_enabled || 
      commPrefs.aft_pur_whatsapp_enabled || 
      commPrefs.aft_pur_others_enabled;

    if (!silent) {
      if (!hasBefPurEnabled) {
        setAlertMsgg({ open: true, content: "Please enable at least one communication preference for 'Before Purchase' section.", type: "error" });
        setTimeout(() => {
          setAlertMsgg((prev) => ({ ...prev, open: false }));
        }, 3000);
        return;
      }

      if (!hasAftPurEnabled) {
        setAlertMsgg({ open: true, content: "Please enable at least one communication preference for 'After Purchase' section.", type: "error" });
        setTimeout(() => {
          setAlertMsgg((prev) => ({ ...prev, open: false }));
        }, 3000);
        return;
      }
    }

    // If no preference is enabled, auto-enable email with user's email
    const userEmail = formik.values.email || JSON.parse(localStorage.getItem('userdata') || '{}').email || "";
    let updatedPrefs = { ...commPrefs };

    if (!hasBefPurEnabled && userEmail) {
      updatedPrefs.bef_pur_email = userEmail;
      updatedPrefs.bef_pur_email_enabled = true;
    }

    if (!hasAftPurEnabled && userEmail) {
      updatedPrefs.aft_pur_email = userEmail;
      updatedPrefs.aft_pur_email_enabled = true;
    }

    // Update state if we made changes
    if (!hasBefPurEnabled || !hasAftPurEnabled) {
      setCommPrefs(updatedPrefs);
    }

    try {
      if (!silent) {
        setshowloader(true);
      }
      const response = await axios.post(`/accounts/partner_communication_preferences`, updatedPrefs);
      if (response.status === "DONE") {
        if (!silent) {
          setAlertMsgg({ open: true, content: "Communication preferences updated successfully!", type: "success" });
          setTimeout(() => {
            setAlertMsgg((prev) => ({ ...prev, open: false }));
          }, 3000);
        }
        setshowloader(false);
        // Refresh the profile to get updated preferences
        if (!silent) {
          fetchPartnerProfile();
        }
      }
    } catch (error:any) {
      if (error.response) {
        if ([401, 422].includes(error.response.status)) {
          setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error || "Error updating preferences", type: "error" });
        } else if (error.response.status === 403) {
          setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
          setTimeout(()=>{window.location.href="/logout"}, 2000);
        } else {
          setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
        }
      } else {
        setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
      }
      setshowloader(false);
    }
  };

  const handleStripeConnectOnboard = async () => {
    try {
      setIsLoadingStripeLink(true);
      const response = await axios.post(`/accounts/create_stripe_connect_link`, {});
      if (response.status === "SENT" && response.onboarding_url) {
        // Redirect to Stripe onboarding link in the same tab
        window.location.href = response.onboarding_url;
      }
    } catch (error:any) {
      setIsLoadingStripeLink(false);
      if (error.response) {
        if ([401, 422].includes(error.response.status)) {
          setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error || "Error creating Stripe Connect link", type: "error" });
        } else if (error.response.status === 403) {
          setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
          setTimeout(()=>{window.location.href="/logout"}, 2000);
        } else {
          setAlertMsgg({ ...alertMsgg, open: true, content: "Error creating Stripe Connect link", type: "error" });
        }
      } else {
        setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
      }
    }
  };

  useEffect(() => {
    fetchPartnerProfile();
    fetchPurchaseAgreements();
    
    // Check if returning from Stripe onboarding
    const urlParams = new URLSearchParams(window.location.search);
    const stripeReturn = urlParams.get('stripe_return');
    const stripeRefresh = urlParams.get('stripe_refresh');
    
    if (stripeReturn || stripeRefresh) {
      // Sync status after returning from Stripe
      setTimeout(() => {
        syncStripeStatus();
      }, 1000);
      // Clean up URL params
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  const syncStripeStatus = async () => {
    try {
      const response = await axios.post(`/accounts/sync_stripe_connect_status`, {});
      if (response.status === "SENT" && response.stripe_connect) {
        setStripeConnectStatus(response.stripe_connect);
        setAlertMsgg({ ...alertMsgg, open: true, content: "Stripe Connect status updated!", type: "success" });
        setTimeout(() => {
          setAlertMsgg((prev) => ({ ...prev, open: false }));
        }, 3000);
      }
    } catch (error:any) {
      console.error("Error syncing Stripe status:", error);
    }
  };

  // Purchase Agreement Functions
  const fetchPurchaseAgreements = async () => {
    try {
      setIsLoadingAgreements(true);
      const response = await axios.get(`${baseUrl}/payments/partner/purchase-agreements/`);
      if (response.status === "SENT") {
        setPurchaseAgreements(response.agreements || []);
      }
    } catch (error: any) {
      console.error("Error fetching purchase agreements:", error);
      if (error.response?.data?.error) {
        setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
        setTimeout(() => {
          setAlertMsgg((prev) => ({ ...prev, open: false }));
        }, 3000);
      }
    } finally {
      setIsLoadingAgreements(false);
    }
  };

  const handleUploadAgreement = async () => {
    if (!uploadFile) {
      setAlertMsgg({ ...alertMsgg, open: true, content: "Please select a file to upload.", type: "error" });
      setTimeout(() => {
        setAlertMsgg((prev) => ({ ...prev, open: false }));
      }, 3000);
      return;
    }

    // Validate file type
    const allowedTypes = ['.pdf', '.doc', '.docx'];
    const fileExt = uploadFile.name.toLowerCase().substring(uploadFile.name.lastIndexOf('.'));
    if (!allowedTypes.includes(fileExt)) {
      setAlertMsgg({ ...alertMsgg, open: true, content: "Invalid file type. Only PDF, DOC, and DOCX files are allowed.", type: "error" });
      setTimeout(() => {
        setAlertMsgg((prev) => ({ ...prev, open: false }));
      }, 3000);
      return;
    }

    // Validate file size (10MB max)
    const maxSize = 10 * 1024 * 1024; // 10MB in bytes
    if (uploadFile.size > maxSize) {
      setAlertMsgg({ ...alertMsgg, open: true, content: "File size exceeds 10MB limit. Please compress or split the document.", type: "error" });
      setTimeout(() => {
        setAlertMsgg((prev) => ({ ...prev, open: false }));
      }, 3000);
      return;
    }

    try {
      setIsLoadingAgreements(true);
      const formData = new FormData();
      formData.append('file', uploadFile);
      formData.append('optional', isOptional.toString());
      formData.append('file_name', uploadFile.name);

      const response = await axios.post(`${baseUrl}/payments/partner/purchase-agreements/upload/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status === "SENT") {
        setAlertMsgg({ ...alertMsgg, open: true, content: "Purchase agreement uploaded successfully!", type: "success" });
        setTimeout(() => {
          setAlertMsgg((prev) => ({ ...prev, open: false }));
        }, 3000);
        setUploadFile(null);
        setIsOptional(false);
        // Reset file input
        const fileInput = document.getElementById('purchaseAgreementFile') as HTMLInputElement;
        if (fileInput) fileInput.value = '';
        fetchPurchaseAgreements();
      }
    } catch (error: any) {
      console.error("Error uploading purchase agreement:", error);
      const errorMsg = error.response?.data?.error || "Failed to upload purchase agreement. Please try again.";
      setAlertMsgg({ ...alertMsgg, open: true, content: errorMsg, type: "error" });
      setTimeout(() => {
        setAlertMsgg((prev) => ({ ...prev, open: false }));
      }, 3000);
    } finally {
      setIsLoadingAgreements(false);
    }
  };

  const handleDeleteAgreement = async (agreementId: number) => {
    if (!window.confirm("Are you sure you want to delete this purchase agreement?")) {
      return;
    }

    try {
      setIsLoadingAgreements(true);
      const response = await axios.delete(`${baseUrl}/payments/partner/purchase-agreements/${agreementId}/`);
      if (response.status === "SENT") {
        setAlertMsgg({ ...alertMsgg, open: true, content: "Purchase agreement deleted successfully!", type: "success" });
        setTimeout(() => {
          setAlertMsgg((prev) => ({ ...prev, open: false }));
        }, 3000);
        fetchPurchaseAgreements();
      }
    } catch (error: any) {
      console.error("Error deleting purchase agreement:", error);
      const errorMsg = error.response?.data?.error || "Failed to delete purchase agreement. Please try again.";
      setAlertMsgg({ ...alertMsgg, open: true, content: errorMsg, type: "error" });
      setTimeout(() => {
        setAlertMsgg((prev) => ({ ...prev, open: false }));
      }, 3000);
    } finally {
      setIsLoadingAgreements(false);
    }
  };
  
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
        {alertMsgg.open && (
            <Alert
            color={alertMsgg.type === "success" ? "success" : "danger"}
            toggle={handleAlertMsggClose}
            style={{ fontWeight: "bold" }}
            >
            {alertMsgg.content}
            </Alert>
            )}
            <div className="loaderContainer" hidden={!showloader}>
            <div className="spinner">
              <div></div>  
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
              <div></div>    
            </div>
          </div>

          <Card className="rounded-4">
            <CardBody>
              <Row>
                <Col md={12}>
                  <Card className="profileCover rounded-4">
                    <CardBody></CardBody>
                  </Card>
                </Col>
                <Col xl={12}>
                  <Card className="bg-transparent">
                    <CardBody>
                      <Form onSubmit={formik.handleSubmit}>
                        <Row className="border-bottom mb-4">
                          <Col md={12} className="profileImgSet">
                            <div
                              className="mb-4 text-center position-relative"
                              style={{ display: "inline-block" }}
                            >
                              <img
                                src={
                                  previewImage
                                    ? previewImage
                                    : typeof formik.values.image === "string"
                                    ? `${baseUrl}${formik.values.image}`
                                    : defaultUserImg
                                }
                                alt="Profile"
                                style={{
                                  width: '100px',
                                  height: '100px',
                                  objectFit: 'cover',
                                  borderRadius: '50%',
                                  border: '2px solid #dee2e6',
                                }}
                                onError={(e) => {
                                  e.currentTarget.onerror = null;
                                  e.currentTarget.src = defaultUserImg;
                                }}
                              />
                              <label htmlFor="upload-profile-pic" className="imgFloatPencil">
                                <i className="bx bxs-pencil"></i>
                              </label>
                              <input
                                type="file"
                                id="upload-profile-pic"
                                accept="image/*"
                                onChange={(e) => handleProfilePicChange(e)}
                                style={{ display: 'none' }}
                              />
                            </div>
                            <p className="mb-0 font-size-18 fw-medium">{formik.values.firstname} {formik.values.lastname}</p>
                            <p className="mb-0 font-size-15">{formik.values.email}</p>
                          </Col>
                          <Col md={3}>
                            <p className="mb-0 font-size-16 text-dark fw-medium">Personal Info</p>
                            <p>You can change your personal information setting here.</p>
                          </Col>
                          <Col md={9}>
                            <Card className="rounded-4 border">
                              <CardBody className="p-4">
                                <Row>
                                  <Col md={6}>
                                    <div className="mb-3">
                                      <Label htmlFor="firstname">First Name<span className="text-danger px-1">*</span></Label>
                                      <Input
                                        type="text"
                                        name="firstname"
                                        id="firstname"
                                        placeholder="Enter your first name"
                                        value={formik.values.firstname}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.firstname && !!formik.errors.firstname}
                                      />
                                      <FormFeedback>{formik.errors.firstname}</FormFeedback>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="mb-3">
                                      <Label htmlFor="lastname">Last Name<span className="text-danger px-1">*</span></Label>
                                      <Input
                                        type="text"
                                        name="lastname"
                                        id="lastname"
                                        placeholder="Enter your last name"
                                        value={formik.values.lastname}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.lastname && !!formik.errors.lastname}
                                      />
                                      <FormFeedback>{formik.errors.lastname}</FormFeedback>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="mb-3">
                                      <Label htmlFor="email">Email<span className="text-danger px-1">*</span></Label>
                                      <Input
                                        type="email"
                                        name="email"
                                        id="email"
                                        placeholder="Enter your email"
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.email && !!formik.errors.email}
                                      />
                                      <FormFeedback>{formik.errors.email}</FormFeedback>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="mb-3">
                                      <Label htmlFor="phone">Phone<span className="text-danger px-1">*</span></Label>
                                      <Input
                                        type="text"
                                        name="phone"
                                        id="phone"
                                        placeholder="Enter your phone number"
                                        value={formik.values.phone}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.phone && !!formik.errors.phone}
                                      />
                                      <FormFeedback>{formik.errors.phone}</FormFeedback>
                                    </div>
                                  </Col>
                                  <Col md={12} className="d-flex justify-content-end">
                                    <Button type="submit" color="primary" className="w-md">
                                      UPDATE 
                                    </Button>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>                   
                        </Row>

                        {/* Company Information Section */}
                        <Row className="border-bottom mb-4">
                          <Col md={3}>
                            <p className="mb-0 font-size-16 text-dark fw-medium">Company Information</p>
                            <p>Provide details about your company.</p>
                          </Col>
                          <Col md={9}>
                            <Card className="rounded-4 border">
                              <CardBody className="p-4">
                                <Row>
                                  <Col md={12}>
                                    <div className="mb-3">
                                      <Label htmlFor="company_name">Company Name</Label>
                                      <Input
                                        type="text"
                                        name="company_name"
                                        id="company_name"
                                        placeholder="Enter company name"
                                        value={formik.values.company_name}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                  </Col>
                                  <Col md={12}>
                                    <div className="mb-3">
                                      <Label htmlFor="company_description">About the Company</Label>
                                      <Input
                                        type="textarea"
                                        name="company_description"
                                        id="company_description"
                                        rows={4}
                                        placeholder="Describe your company"
                                        value={formik.values.company_description}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="mb-3">
                                      <Label htmlFor="industry">Industry/Sector</Label>
                                      <Input
                                        type="text"
                                        name="industry"
                                        id="industry"
                                        placeholder="e.g., Technology, Finance, Healthcare"
                                        value={formik.values.industry}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="mb-3">
                                      <Label htmlFor="company_size">Company Size</Label>
                                      <Input
                                        type="select"
                                        name="company_size"
                                        id="company_size"
                                        value={formik.values.company_size}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                      >
                                        <option value="">Select company size</option>
                                        <option value="startup">Startup</option>
                                        <option value="small">Small (1-50 employees)</option>
                                        <option value="medium">Medium (51-200 employees)</option>
                                        <option value="large">Large (201-1000 employees)</option>
                                        <option value="enterprise">Enterprise (1000+ employees)</option>
                                      </Input>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="mb-3">
                                      <Label htmlFor="years_in_business">Years in Business</Label>
                                      <Input
                                        type="number"
                                        name="years_in_business"
                                        id="years_in_business"
                                        placeholder="e.g., 5"
                                        value={formik.values.years_in_business}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.years_in_business && !!formik.errors.years_in_business}
                                        min="0"
                                      />
                                      <FormFeedback>{formik.errors.years_in_business}</FormFeedback>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="mb-3">
                                      <Label htmlFor="number_of_employees">Number of Employees</Label>
                                      <Input
                                        type="number"
                                        name="number_of_employees"
                                        id="number_of_employees"
                                        placeholder="e.g., 50"
                                        value={formik.values.number_of_employees}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.number_of_employees && !!formik.errors.number_of_employees}
                                        min="0"
                                      />
                                      <FormFeedback>{formik.errors.number_of_employees}</FormFeedback>
                                    </div>
                                  </Col>
                                  <Col md={12}>
                                    <div className="mb-3">
                                      <Label htmlFor="service_areas">Service Areas/Regions</Label>
                                      <Input
                                        type="textarea"
                                        name="service_areas"
                                        id="service_areas"
                                        rows={2}
                                        placeholder="List the regions or areas you serve (e.g., United States, Canada, Europe)"
                                        value={formik.values.service_areas}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                  </Col>
                                  <Col md={12}>
                                    <div className="mb-3">
                                      <Label htmlFor="specializations">Specializations/Expertise Areas</Label>
                                      <Input
                                        type="textarea"
                                        name="specializations"
                                        id="specializations"
                                        rows={2}
                                        placeholder="List your areas of expertise or specializations"
                                        value={formik.values.specializations}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                  </Col>
                                  <Col md={12}>
                                    <div className="mb-3">
                                      <Label className="fw-medium">Address</Label>
                                    </div>
                                  </Col>
                                  <Col md={12}>
                                    <div className="mb-3">
                                      <Label htmlFor="address_line1">Address Line 1</Label>
                                      <Input
                                        type="text"
                                        name="address_line1"
                                        id="address_line1"
                                        placeholder="Street address"
                                        value={formik.values.address_line1}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                  </Col>
                                  <Col md={12}>
                                    <div className="mb-3">
                                      <Label htmlFor="address_line2">Address Line 2</Label>
                                      <Input
                                        type="text"
                                        name="address_line2"
                                        id="address_line2"
                                        placeholder="Apartment, suite, etc. (optional)"
                                        value={formik.values.address_line2}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4}>
                                    <div className="mb-3">
                                      <Label htmlFor="city">City</Label>
                                      <Input
                                        type="text"
                                        name="city"
                                        id="city"
                                        placeholder="City"
                                        value={formik.values.city}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4}>
                                    <div className="mb-3">
                                      <Label htmlFor="state">State/Province</Label>
                                      <Input
                                        type="text"
                                        name="state"
                                        id="state"
                                        placeholder="State/Province"
                                        value={formik.values.state}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4}>
                                    <div className="mb-3">
                                      <Label htmlFor="zipcode">Zip/Postal Code</Label>
                                      <Input
                                        type="text"
                                        name="zipcode"
                                        id="zipcode"
                                        placeholder="Zip/Postal Code"
                                        value={formik.values.zipcode}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                  </Col>
                                  <Col md={12}>
                                    <div className="mb-3">
                                      <Label htmlFor="country">Country</Label>
                                      <Input
                                        type="text"
                                        name="country"
                                        id="country"
                                        placeholder="Country"
                                        value={formik.values.country}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                  </Col>
                                  <Col md={12}>
                                    <div className="mb-3">
                                      <Label className="fw-medium">Website & Social Media</Label>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="mb-3">
                                      <Label htmlFor="website">Website</Label>
                                      <Input
                                        type="url"
                                        name="website"
                                        id="website"
                                        placeholder="https://www.example.com"
                                        value={formik.values.website}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.website && !!formik.errors.website}
                                      />
                                      <FormFeedback>{formik.errors.website}</FormFeedback>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="mb-3">
                                      <Label htmlFor="linkedin_url">LinkedIn</Label>
                                      <Input
                                        type="url"
                                        name="linkedin_url"
                                        id="linkedin_url"
                                        placeholder="https://www.linkedin.com/company/example"
                                        value={formik.values.linkedin_url}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.linkedin_url && !!formik.errors.linkedin_url}
                                      />
                                      <FormFeedback>{formik.errors.linkedin_url}</FormFeedback>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="mb-3">
                                      <Label htmlFor="facebook_url">Facebook</Label>
                                      <Input
                                        type="url"
                                        name="facebook_url"
                                        id="facebook_url"
                                        placeholder="https://www.facebook.com/example"
                                        value={formik.values.facebook_url}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.facebook_url && !!formik.errors.facebook_url}
                                      />
                                      <FormFeedback>{formik.errors.facebook_url}</FormFeedback>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="mb-3">
                                      <Label htmlFor="x_url">X (Twitter)</Label>
                                      <Input
                                        type="url"
                                        name="x_url"
                                        id="x_url"
                                        placeholder="https://twitter.com/example"
                                        value={formik.values.x_url}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.x_url && !!formik.errors.x_url}
                                      />
                                      <FormFeedback>{formik.errors.x_url}</FormFeedback>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="mb-3">
                                      <Label htmlFor="instagram_url">Instagram</Label>
                                      <Input
                                        type="url"
                                        name="instagram_url"
                                        id="instagram_url"
                                        placeholder="https://www.instagram.com/example"
                                        value={formik.values.instagram_url}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.instagram_url && !!formik.errors.instagram_url}
                                      />
                                      <FormFeedback>{formik.errors.instagram_url}</FormFeedback>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="mb-3">
                                      <Label htmlFor="youtube_url">YouTube</Label>
                                      <Input
                                        type="url"
                                        name="youtube_url"
                                        id="youtube_url"
                                        placeholder="https://www.youtube.com/@example"
                                        value={formik.values.youtube_url}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        invalid={formik.touched.youtube_url && !!formik.errors.youtube_url}
                                      />
                                      <FormFeedback>{formik.errors.youtube_url}</FormFeedback>
                                    </div>
                                  </Col>
                                  <Col md={12} className="d-flex justify-content-end">
                                    <Button type="submit" color="primary" className="w-md">
                                      UPDATE COMPANY INFO
                                    </Button>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>

                        <Row className="border-bottom mb-4">
                          <Col md={4}>
                            <p className="mb-0 font-size-16 text-dark fw-medium">Change Password</p>
                            <p></p>
                          </Col>
                          <Col md={12}>
                            <Card className="rounded-4 border">
                              <CardBody className="p-4">
                                <Row>
                                  <Col md={4}>
                                    <div className="mb-3">
                                      <Label htmlFor="currentPassword">
                                        Current Password <span className="text-danger px-1">*</span>
                                      </Label>
                                      <InputGroup>
                                        <Input
                                          type={showCurrent ? "text" : "password"}
                                          name="currentPassword"
                                          id="currentPassword"
                                          placeholder="Enter current password"
                                          value={formik.values.currentPassword}
                                          onChange={formik.handleChange}
                                          onBlur={formik.handleBlur}
                                          invalid={
                                            formik.touched.currentPassword &&
                                            !!formik.errors.currentPassword
                                          }
                                        />
                                        <InputGroupText
                                          role="button"
                                          onClick={() => setShowCurrent(!showCurrent)}
                                          style={{ cursor: "pointer" }}
                                        >
                                          <i className={`mdi ${showCurrent ? "mdi-eye-off" : "mdi-eye"}`}></i>
                                        </InputGroupText>
                                        <FormFeedback>{formik.errors.currentPassword}</FormFeedback>
                                      </InputGroup>
                                    </div>
                                  </Col>
                                  <Col md={4}>
                                    <div className="mb-3">
                                      <Label htmlFor="newPassword">
                                        New Password <span className="text-danger px-1">*</span>
                                      </Label>
                                      <InputGroup>
                                        <Input
                                          type={showNew ? "text" : "password"}
                                          name="newPassword"
                                          id="newPassword"
                                          placeholder="Enter new password"
                                          value={formik.values.newPassword}
                                          onChange={formik.handleChange}
                                          onBlur={formik.handleBlur}
                                          invalid={
                                            formik.touched.newPassword &&
                                            !!formik.errors.newPassword
                                          }
                                        />
                                        <InputGroupText
                                          role="button"
                                          onClick={() => setShowNew(!showNew)}
                                          style={{ cursor: "pointer" }}
                                        >
                                          <i className={`mdi ${showNew ? "mdi-eye-off" : "mdi-eye"}`}></i>
                                        </InputGroupText>
                                      <FormFeedback>{formik.errors.newPassword}</FormFeedback>
                                      </InputGroup>
                                      <small className="text-muted d-block mt-1">
                                        <strong>Password Requirements:</strong>
                                        <ul className="mb-0 ps-3" style={{ fontSize: "0.85rem" }}>
                                          <li>At least 6 characters</li>
                                          <li>One uppercase letter (A-Z)</li>
                                          <li>One number (0-9)</li>
                                          <li>One special character (!@#$%^&*...)</li>
                                        </ul>
                                      </small>
                                    </div>
                                  </Col>
                                  <Col md={4}>
                                    <div className="mb-3">
                                      <Label htmlFor="confirmPassword">
                                        Confirm Password <span className="text-danger px-1">*</span>
                                      </Label>
                                      <InputGroup>
                                        <Input
                                          type={showConfirm ? "text" : "password"}
                                          name="confirmPassword"
                                          id="confirmPassword"
                                          placeholder="Confirm new password"
                                          value={formik.values.confirmPassword}
                                          onChange={formik.handleChange}
                                          onBlur={formik.handleBlur}
                                          invalid={
                                            formik.touched.confirmPassword &&
                                            !!formik.errors.confirmPassword
                                          }
                                        />
                                        <InputGroupText
                                          role="button"
                                          onClick={() => setShowConfirm(!showConfirm)}
                                          style={{ cursor: "pointer" }}
                                        >
                                          <i className={`mdi ${showConfirm ? "mdi-eye-off" : "mdi-eye"}`}></i>
                                        </InputGroupText>
                                      <FormFeedback>{formik.errors.confirmPassword}</FormFeedback>
                                      </InputGroup>
                                    </div>
                                  </Col>
                                  <Col md={12} className="d-flex justify-content-end">
                                    <Button onClick={handlePasswordUpdate} color="primary" className="w-md">
                                      Update Password
                                    </Button>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>

                        {/* Stripe Connect Status Section */}
                        <Row className="border-bottom mb-4">
                          <Col md={3}>
                            <p className="mb-0 font-size-16 text-dark fw-medium">Stripe Connect</p>
                            <p>Manage your payment account setup.</p>
                          </Col>
                          <Col md={9}>
                            <Card className="rounded-4 border">
                              <CardBody className="p-4">
                                {stripeConnectStatus && (
                                  <div>
                                    <div className="mb-3">
                                      <Label className="fw-medium">Status:</Label>
                                      <span className={`ms-2 badge ${stripeConnectStatus.is_onboarded ? 'bg-success' : stripeConnectStatus.onboarding_status === 'in_progress' ? 'bg-warning' : 'bg-secondary'}`}>
                                        {stripeConnectStatus.is_onboarded 
                                          ? 'Connected' 
                                          : stripeConnectStatus.onboarding_status === 'in_progress' 
                                          ? 'Onboarding in Progress' 
                                          : 'Not Connected'}
                                      </span>
                                    </div>
                                    {stripeConnectStatus.stripe_account_id && !stripeConnectStatus.is_onboarded && (
                                      <div className="mt-3">
                                        <Button 
                                          color="primary" 
                                          onClick={handleStripeConnectOnboard}
                                          disabled={isLoadingStripeLink}
                                        >
                                          {isLoadingStripeLink ? 'Creating Link...' : 'Update Account Details'}
                                        </Button>
                                        <p className="text-muted mt-2 mb-0 small">
                                          Click to update your Stripe Connect account details. This will open in a new tab.
                                        </p>
                                      </div>
                                    )}
                                    {!stripeConnectStatus.stripe_account_id && (
                                      <div className="mt-3">
                                        <Button 
                                          color="primary" 
                                          onClick={handleStripeConnectOnboard}
                                          disabled={isLoadingStripeLink}
                                        >
                                          {isLoadingStripeLink ? 'Creating Link...' : 'Connect Stripe Account'}
                                        </Button>
                                        <p className="text-muted mt-2 mb-0 small">
                                          Click to start the Stripe Connect onboarding process. This will open in a new tab.
                                        </p>
                                      </div>
                                    )}
                                    {stripeConnectStatus.is_onboarded && (
                                      <div className="mt-3">
                                        <div className="mb-2">
                                          <p className="text-success mb-2">
                                            <i className="bx bx-check-circle me-1"></i>
                                            Your Stripe account is connected and ready to receive payments.
                                          </p>
                                        </div>
                                        <Button 
                                          color="secondary" 
                                          onClick={handleStripeConnectOnboard}
                                          disabled={isLoadingStripeLink}
                                        >
                                          {isLoadingStripeLink ? 'Creating Link...' : 'Update Account Details'}
                                        </Button>
                                        <p className="text-muted mt-2 mb-0 small">
                                          Click to update your Stripe Connect account information. This will open in a new tab.
                                        </p>
                                      </div>
                                    )}
                                  </div>
                                )}
                                {!stripeConnectStatus && (
                                  <div>
                                    <p className="text-muted">Loading Stripe Connect status...</p>
                                  </div>
                                )}
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>

                        {/* Communication Preferences Section */}
                        <Row className="border-bottom mb-4">
                          <Col md={3}>
                            <p className="mb-0 font-size-16 text-dark fw-medium">Communication Preferences</p>
                            <p>Set your preferred communication methods for before and after purchase.</p>
                          </Col>
                          <Col md={9}>
                            <Card className="rounded-4 border">
                              <CardBody className="p-4">
                                <Row>
                                  {/* Before Purchase Section */}
                                  <Col md={6} style={{borderRight: '1px solid #dee2e6', paddingRight: '2rem'}}>
                                    <div className="mb-4">
                                      <h5 className="mb-1 text-primary">Before Purchase</h5>
                                      <p className="text-muted mb-3" style={{fontSize: '0.75rem', fontWeight: '300'}}>This is how potential clients would contact you before making a purchase.</p>
                                      <Row>
                                    <Col md={6}>
                                      <div className="mb-3">
                                        <div className="d-flex align-items-center mb-2">
                                          <Input
                                            type="checkbox"
                                            checked={commPrefs.bef_pur_email_enabled}
                                            onChange={(e) => setCommPrefs({...commPrefs, bef_pur_email_enabled: e.target.checked})}
                                            className="form-check-input"
                                            style={{width: '18px', height: '18px', marginRight: '8px', cursor: 'pointer'}}
                                          />
                                          <Label className="mb-0" style={{cursor: 'pointer'}}>
                                            <i className="bx bx-envelope me-2" style={{color: '#000000'}}></i>Email
                                          </Label>
                                        </div>
                                        <Input
                                          type="email"
                                          placeholder="Email for communication before purchase"
                                          value={commPrefs.bef_pur_email}
                                          onChange={(e) => setCommPrefs({...commPrefs, bef_pur_email: e.target.value})}
                                          onBlur={(e) => {
                                            if (e.target.value && !validateEmail(e.target.value)) {
                                              setAlertMsgg({ open: true, content: "Please enter a valid email address", type: "error" });
                                              setTimeout(() => setAlertMsgg(prev => ({ ...prev, open: false })), 3000);
                                            }
                                          }}
                                          invalid={commPrefs.bef_pur_email ? !validateEmail(commPrefs.bef_pur_email) : false}
                                          disabled={!commPrefs.bef_pur_email_enabled}
                                        />
                                        <small style={{color: '#999999'}}>Example: partner@example.com</small>
                                      </div>
                                    </Col>
                                    <Col md={6}>
                                      <div className="mb-3">
                                        <div className="d-flex align-items-center mb-2">
                                          <Input
                                            type="checkbox"
                                            checked={commPrefs.bef_pur_phone_enabled}
                                            onChange={(e) => setCommPrefs({...commPrefs, bef_pur_phone_enabled: e.target.checked})}
                                            className="form-check-input"
                                            style={{width: '18px', height: '18px', marginRight: '8px', cursor: 'pointer'}}
                                          />
                                          <Label className="mb-0" style={{cursor: 'pointer'}}>
                                            <i className="bx bx-phone me-2" style={{color: '#25D366'}}></i>Phone
                                          </Label>
                                        </div>
                                        <Input
                                          type="text"
                                          placeholder="Phone number for communication before purchase"
                                          value={commPrefs.bef_pur_phone}
                                          onChange={(e) => handlePhoneChange(e.target.value, (val) => setCommPrefs({...commPrefs, bef_pur_phone: val}))}
                                          maxLength={10}
                                          disabled={!commPrefs.bef_pur_phone_enabled}
                                        />
                                        <small style={{color: '#999999'}}>Example: 1234567890 (10 digits only)</small>
                                      </div>
                                    </Col>
                                    <Col md={6}>
                                      <div className="mb-3">
                                        <div className="d-flex align-items-center mb-2">
                                          <Input
                                            type="checkbox"
                                            checked={commPrefs.bef_pur_calendly_enabled}
                                            onChange={(e) => setCommPrefs({...commPrefs, bef_pur_calendly_enabled: e.target.checked})}
                                            className="form-check-input"
                                            style={{width: '18px', height: '18px', marginRight: '8px', cursor: 'pointer'}}
                                          />
                                          <Label className="mb-0" style={{cursor: 'pointer'}}>
                                            <i className="bx bx-calendar me-2" style={{color: '#0069FF'}}></i>Calendly
                                          </Label>
                                        </div>
                                        <Input
                                          type="url"
                                          placeholder="Calendly link"
                                          value={commPrefs.bef_pur_calendly}
                                          onChange={(e) => setCommPrefs({...commPrefs, bef_pur_calendly: e.target.value})}
                                          onBlur={(e) => {
                                            if (e.target.value && !validateURL(e.target.value)) {
                                              setAlertMsgg({ open: true, content: "Please enter a valid URL", type: "error" });
                                              setTimeout(() => setAlertMsgg(prev => ({ ...prev, open: false })), 3000);
                                            }
                                          }}
                                          invalid={commPrefs.bef_pur_calendly ? !validateURL(commPrefs.bef_pur_calendly) : false}
                                          disabled={!commPrefs.bef_pur_calendly_enabled}
                                        />
                                        <small style={{color: '#999999'}}>Example: https://calendly.com/yourname</small>
                                      </div>
                                    </Col>
                                    <Col md={6}>
                                      <div className="mb-3">
                                        <div className="d-flex align-items-center mb-2">
                                          <Input
                                            type="checkbox"
                                            checked={commPrefs.bef_pur_zoom_enabled}
                                            onChange={(e) => setCommPrefs({...commPrefs, bef_pur_zoom_enabled: e.target.checked})}
                                            className="form-check-input"
                                            style={{width: '18px', height: '18px', marginRight: '8px', cursor: 'pointer'}}
                                          />
                                          <Label className="mb-0" style={{cursor: 'pointer'}}>
                                            <i className="bx bx-video me-2" style={{color: '#2D8CFF'}}></i>Zoom
                                          </Label>
                                        </div>
                                        <Input
                                          type="url"
                                          placeholder="Zoom link"
                                          value={commPrefs.bef_pur_zoom}
                                          onChange={(e) => setCommPrefs({...commPrefs, bef_pur_zoom: e.target.value})}
                                          onBlur={(e) => {
                                            if (e.target.value && !validateURL(e.target.value)) {
                                              setAlertMsgg({ open: true, content: "Please enter a valid URL", type: "error" });
                                              setTimeout(() => setAlertMsgg(prev => ({ ...prev, open: false })), 3000);
                                            }
                                          }}
                                          invalid={commPrefs.bef_pur_zoom ? !validateURL(commPrefs.bef_pur_zoom) : false}
                                          disabled={!commPrefs.bef_pur_zoom_enabled}
                                        />
                                        <small style={{color: '#999999'}}>Example: https://zoom.us/j/123456789</small>
                                      </div>
                                    </Col>
                                    <Col md={6}>
                                      <div className="mb-3">
                                        <div className="d-flex align-items-center mb-2">
                                          <Input
                                            type="checkbox"
                                            checked={commPrefs.bef_pur_teams_enabled}
                                            onChange={(e) => setCommPrefs({...commPrefs, bef_pur_teams_enabled: e.target.checked})}
                                            className="form-check-input"
                                            style={{width: '18px', height: '18px', marginRight: '8px', cursor: 'pointer'}}
                                          />
                                          <Label className="mb-0" style={{cursor: 'pointer'}}>
                                            <Users size={16} className="me-2" style={{color: '#6264A7', display: 'inline-block', verticalAlign: 'middle'}} />Teams
                                          </Label>
                                        </div>
                                        <Input
                                          type="url"
                                          placeholder="Microsoft Teams link"
                                          value={commPrefs.bef_pur_teams}
                                          onChange={(e) => setCommPrefs({...commPrefs, bef_pur_teams: e.target.value})}
                                          onBlur={(e) => {
                                            if (e.target.value && !validateURL(e.target.value)) {
                                              setAlertMsgg({ open: true, content: "Please enter a valid URL", type: "error" });
                                              setTimeout(() => setAlertMsgg(prev => ({ ...prev, open: false })), 3000);
                                            }
                                          }}
                                          invalid={commPrefs.bef_pur_teams ? !validateURL(commPrefs.bef_pur_teams) : false}
                                          disabled={!commPrefs.bef_pur_teams_enabled}
                                        />
                                        <small style={{color: '#999999'}}>Example: https://teams.microsoft.com/l/meetup-join/...</small>
                                      </div>
                                    </Col>
                                    <Col md={6}>
                                      <div className="mb-3">
                                        <div className="d-flex align-items-center mb-2">
                                          <Input
                                            type="checkbox"
                                            checked={commPrefs.bef_pur_whatsapp_enabled}
                                            onChange={(e) => setCommPrefs({...commPrefs, bef_pur_whatsapp_enabled: e.target.checked})}
                                            className="form-check-input"
                                            style={{width: '18px', height: '18px', marginRight: '8px', cursor: 'pointer'}}
                                          />
                                          <Label className="mb-0" style={{cursor: 'pointer'}}>
                                            <i className="bx bxl-whatsapp me-2" style={{color: '#25D366'}}></i>WhatsApp
                                          </Label>
                                        </div>
                                        <Input
                                          type="text"
                                          placeholder="WhatsApp number"
                                          value={commPrefs.bef_pur_whatsapp}
                                          onChange={(e) => handlePhoneChange(e.target.value, (val) => setCommPrefs({...commPrefs, bef_pur_whatsapp: val}))}
                                          maxLength={10}
                                          disabled={!commPrefs.bef_pur_whatsapp_enabled}
                                        />
                                        <small style={{color: '#999999'}}>Example: 1234567890 (10 digits only)</small>
                                      </div>
                                    </Col>
                                    <Col md={6}>
                                      <div className="mb-3">
                                        <div className="d-flex align-items-center mb-2">
                                          <Input
                                            type="checkbox"
                                            checked={commPrefs.bef_pur_others_enabled}
                                            onChange={(e) => setCommPrefs({...commPrefs, bef_pur_others_enabled: e.target.checked})}
                                            className="form-check-input"
                                            style={{width: '18px', height: '18px', marginRight: '8px', cursor: 'pointer'}}
                                          />
                                          <Label className="mb-0" style={{cursor: 'pointer'}}>
                                            <i className="bx bx-dots-horizontal-rounded me-2" style={{color: '#000000'}}></i>Others
                                          </Label>
                                        </div>
                                        <Input
                                          type="text"
                                          placeholder="Other communication method/link"
                                          value={commPrefs.bef_pur_others}
                                          onChange={(e) => setCommPrefs({...commPrefs, bef_pur_others: e.target.value})}
                                          onBlur={(e) => {
                                            if (e.target.value && e.target.value.startsWith('http') && !validateURL(e.target.value)) {
                                              setAlertMsgg({ open: true, content: "Please enter a valid URL", type: "error" });
                                              setTimeout(() => setAlertMsgg(prev => ({ ...prev, open: false })), 3000);
                                            }
                                          }}
                                          invalid={commPrefs.bef_pur_others && commPrefs.bef_pur_others.startsWith('http') ? !validateURL(commPrefs.bef_pur_others) : false}
                                          disabled={!commPrefs.bef_pur_others_enabled}
                                        />
                                        <small style={{color: '#999999'}}>Example: https://example.com or any other method</small>
                                      </div>
                                    </Col>
                                    <Col md={12}>
                                      <div className="mb-3">
                                        <Label>
                                          <i className="bx bx-note me-2"></i>Notes
                                        </Label>
                                        <Input
                                          type="textarea"
                                          rows={3}
                                          placeholder="Additional notes for communication before purchase"
                                          value={commPrefs.bef_pur_notes}
                                          onChange={(e) => setCommPrefs({...commPrefs, bef_pur_notes: e.target.value})}
                                        />
                                      </div>
                                    </Col>
                                    <Col md={12} className="d-flex justify-content-end">
                                      <Button onClick={() => handleCommPrefUpdate()} color="primary" className="w-md">
                                        Update Before Purchase Preferences
                                      </Button>
                                    </Col>
                                      </Row>
                                    </div>
                                  </Col>

                                  {/* After Purchase Section */}
                                  <Col md={6} style={{paddingLeft: '2rem'}}>
                                    <div className="mb-4">
                                      <h5 className="mb-1 text-success">After Purchase</h5>
                                      <p className="text-muted mb-3" style={{fontSize: '0.75rem', fontWeight: '300'}}>This is how current clients would contact you after making a purchase.</p>
                                      <Row>
                                    <Col md={6}>
                                      <div className="mb-3">
                                        <div className="d-flex align-items-center mb-2">
                                          <Input
                                            type="checkbox"
                                            checked={commPrefs.aft_pur_email_enabled}
                                            onChange={(e) => setCommPrefs({...commPrefs, aft_pur_email_enabled: e.target.checked})}
                                            className="form-check-input"
                                            style={{width: '18px', height: '18px', marginRight: '8px', cursor: 'pointer'}}
                                          />
                                          <Label className="mb-0" style={{cursor: 'pointer'}}>
                                            <i className="bx bx-envelope me-2" style={{color: '#000000'}}></i>Email
                                          </Label>
                                        </div>
                                        <Input
                                          type="email"
                                          placeholder="Email for communication after purchase"
                                          value={commPrefs.aft_pur_email}
                                          onChange={(e) => setCommPrefs({...commPrefs, aft_pur_email: e.target.value})}
                                          onBlur={(e) => {
                                            if (e.target.value && !validateEmail(e.target.value)) {
                                              setAlertMsgg({ open: true, content: "Please enter a valid email address", type: "error" });
                                              setTimeout(() => setAlertMsgg(prev => ({ ...prev, open: false })), 3000);
                                            }
                                          }}
                                          invalid={commPrefs.aft_pur_email ? !validateEmail(commPrefs.aft_pur_email) : false}
                                          disabled={!commPrefs.aft_pur_email_enabled}
                                        />
                                        <small style={{color: '#999999'}}>Example: partner@example.com</small>
                                      </div>
                                    </Col>
                                    <Col md={6}>
                                      <div className="mb-3">
                                        <div className="d-flex align-items-center mb-2">
                                          <Input
                                            type="checkbox"
                                            checked={commPrefs.aft_pur_phone_enabled}
                                            onChange={(e) => setCommPrefs({...commPrefs, aft_pur_phone_enabled: e.target.checked})}
                                            className="form-check-input"
                                            style={{width: '18px', height: '18px', marginRight: '8px', cursor: 'pointer'}}
                                          />
                                          <Label className="mb-0" style={{cursor: 'pointer'}}>
                                            <i className="bx bx-phone me-2" style={{color: '#25D366'}}></i>Phone
                                          </Label>
                                        </div>
                                        <Input
                                          type="text"
                                          placeholder="Phone number for communication after purchase"
                                          value={commPrefs.aft_pur_phone}
                                          onChange={(e) => handlePhoneChange(e.target.value, (val) => setCommPrefs({...commPrefs, aft_pur_phone: val}))}
                                          maxLength={10}
                                          disabled={!commPrefs.aft_pur_phone_enabled}
                                        />
                                        <small style={{color: '#999999'}}>Example: 1234567890 (10 digits only)</small>
                                      </div>
                                    </Col>
                                    <Col md={6}>
                                      <div className="mb-3">
                                        <div className="d-flex align-items-center mb-2">
                                          <Input
                                            type="checkbox"
                                            checked={commPrefs.aft_pur_calendly_enabled}
                                            onChange={(e) => setCommPrefs({...commPrefs, aft_pur_calendly_enabled: e.target.checked})}
                                            className="form-check-input"
                                            style={{width: '18px', height: '18px', marginRight: '8px', cursor: 'pointer'}}
                                          />
                                          <Label className="mb-0" style={{cursor: 'pointer'}}>
                                            <i className="bx bx-calendar me-2" style={{color: '#0069FF'}}></i>Calendly
                                          </Label>
                                        </div>
                                        <Input
                                          type="url"
                                          placeholder="Calendly link"
                                          value={commPrefs.aft_pur_calendly}
                                          onChange={(e) => setCommPrefs({...commPrefs, aft_pur_calendly: e.target.value})}
                                          onBlur={(e) => {
                                            if (e.target.value && !validateURL(e.target.value)) {
                                              setAlertMsgg({ open: true, content: "Please enter a valid URL", type: "error" });
                                              setTimeout(() => setAlertMsgg(prev => ({ ...prev, open: false })), 3000);
                                            }
                                          }}
                                          invalid={commPrefs.aft_pur_calendly ? !validateURL(commPrefs.aft_pur_calendly) : false}
                                          disabled={!commPrefs.aft_pur_calendly_enabled}
                                        />
                                        <small style={{color: '#999999'}}>Example: https://calendly.com/yourname</small>
                                      </div>
                                    </Col>
                                    <Col md={6}>
                                      <div className="mb-3">
                                        <div className="d-flex align-items-center mb-2">
                                          <Input
                                            type="checkbox"
                                            checked={commPrefs.aft_pur_zoom_enabled}
                                            onChange={(e) => setCommPrefs({...commPrefs, aft_pur_zoom_enabled: e.target.checked})}
                                            className="form-check-input"
                                            style={{width: '18px', height: '18px', marginRight: '8px', cursor: 'pointer'}}
                                          />
                                          <Label className="mb-0" style={{cursor: 'pointer'}}>
                                            <i className="bx bx-video me-2" style={{color: '#2D8CFF'}}></i>Zoom
                                          </Label>
                                        </div>
                                        <Input
                                          type="url"
                                          placeholder="Zoom link"
                                          value={commPrefs.aft_pur_zoom}
                                          onChange={(e) => setCommPrefs({...commPrefs, aft_pur_zoom: e.target.value})}
                                          onBlur={(e) => {
                                            if (e.target.value && !validateURL(e.target.value)) {
                                              setAlertMsgg({ open: true, content: "Please enter a valid URL", type: "error" });
                                              setTimeout(() => setAlertMsgg(prev => ({ ...prev, open: false })), 3000);
                                            }
                                          }}
                                          invalid={commPrefs.aft_pur_zoom ? !validateURL(commPrefs.aft_pur_zoom) : false}
                                          disabled={!commPrefs.aft_pur_zoom_enabled}
                                        />
                                        <small style={{color: '#999999'}}>Example: https://zoom.us/j/123456789</small>
                                      </div>
                                    </Col>
                                    <Col md={6}>
                                      <div className="mb-3">
                                        <div className="d-flex align-items-center mb-2">
                                          <Input
                                            type="checkbox"
                                            checked={commPrefs.aft_pur_teams_enabled}
                                            onChange={(e) => setCommPrefs({...commPrefs, aft_pur_teams_enabled: e.target.checked})}
                                            className="form-check-input"
                                            style={{width: '18px', height: '18px', marginRight: '8px', cursor: 'pointer'}}
                                          />
                                          <Label className="mb-0" style={{cursor: 'pointer'}}>
                                            <Users size={16} className="me-2" style={{color: '#6264A7', display: 'inline-block', verticalAlign: 'middle'}} />Teams
                                          </Label>
                                        </div>
                                        <Input
                                          type="url"
                                          placeholder="Microsoft Teams link"
                                          value={commPrefs.aft_pur_teams}
                                          onChange={(e) => setCommPrefs({...commPrefs, aft_pur_teams: e.target.value})}
                                          onBlur={(e) => {
                                            if (e.target.value && !validateURL(e.target.value)) {
                                              setAlertMsgg({ open: true, content: "Please enter a valid URL", type: "error" });
                                              setTimeout(() => setAlertMsgg(prev => ({ ...prev, open: false })), 3000);
                                            }
                                          }}
                                          invalid={commPrefs.aft_pur_teams ? !validateURL(commPrefs.aft_pur_teams) : false}
                                          disabled={!commPrefs.aft_pur_teams_enabled}
                                        />
                                        <small style={{color: '#999999'}}>Example: https://teams.microsoft.com/l/meetup-join/...</small>
                                      </div>
                                    </Col>
                                    <Col md={6}>
                                      <div className="mb-3">
                                        <div className="d-flex align-items-center mb-2">
                                          <Input
                                            type="checkbox"
                                            checked={commPrefs.aft_pur_whatsapp_enabled}
                                            onChange={(e) => setCommPrefs({...commPrefs, aft_pur_whatsapp_enabled: e.target.checked})}
                                            className="form-check-input"
                                            style={{width: '18px', height: '18px', marginRight: '8px', cursor: 'pointer'}}
                                          />
                                          <Label className="mb-0" style={{cursor: 'pointer'}}>
                                            <i className="bx bxl-whatsapp me-2" style={{color: '#25D366'}}></i>WhatsApp
                                          </Label>
                                        </div>
                                        <Input
                                          type="text"
                                          placeholder="WhatsApp number"
                                          value={commPrefs.aft_pur_whatsapp}
                                          onChange={(e) => handlePhoneChange(e.target.value, (val) => setCommPrefs({...commPrefs, aft_pur_whatsapp: val}))}
                                          maxLength={10}
                                          disabled={!commPrefs.aft_pur_whatsapp_enabled}
                                        />
                                        <small style={{color: '#999999'}}>Example: 1234567890 (10 digits only)</small>
                                      </div>
                                    </Col>
                                    <Col md={6}>
                                      <div className="mb-3">
                                        <div className="d-flex align-items-center mb-2">
                                          <Input
                                            type="checkbox"
                                            checked={commPrefs.aft_pur_others_enabled}
                                            onChange={(e) => setCommPrefs({...commPrefs, aft_pur_others_enabled: e.target.checked})}
                                            className="form-check-input"
                                            style={{width: '18px', height: '18px', marginRight: '8px', cursor: 'pointer'}}
                                          />
                                          <Label className="mb-0" style={{cursor: 'pointer'}}>
                                            <i className="bx bx-dots-horizontal-rounded me-2" style={{color: '#000000'}}></i>Others
                                          </Label>
                                        </div>
                                        <Input
                                          type="text"
                                          placeholder="Other communication method/link"
                                          value={commPrefs.aft_pur_others}
                                          onChange={(e) => setCommPrefs({...commPrefs, aft_pur_others: e.target.value})}
                                          onBlur={(e) => {
                                            if (e.target.value && e.target.value.startsWith('http') && !validateURL(e.target.value)) {
                                              setAlertMsgg({ open: true, content: "Please enter a valid URL", type: "error" });
                                              setTimeout(() => setAlertMsgg(prev => ({ ...prev, open: false })), 3000);
                                            }
                                          }}
                                          invalid={commPrefs.aft_pur_others && commPrefs.aft_pur_others.startsWith('http') ? !validateURL(commPrefs.aft_pur_others) : false}
                                          disabled={!commPrefs.aft_pur_others_enabled}
                                        />
                                        <small style={{color: '#999999'}}>Example: https://example.com or any other method</small>
                                      </div>
                                    </Col>
                                    <Col md={12}>
                                      <div className="mb-3">
                                        <Label>
                                          <i className="bx bx-note me-2"></i>Notes
                                        </Label>
                                        <Input
                                          type="textarea"
                                          rows={3}
                                          placeholder="Additional notes for communication after purchase"
                                          value={commPrefs.aft_pur_notes}
                                          onChange={(e) => setCommPrefs({...commPrefs, aft_pur_notes: e.target.value})}
                                        />
                                      </div>
                                    </Col>
                                    <Col md={12} className="d-flex justify-content-end">
                                      <Button onClick={() => handleCommPrefUpdate()} color="primary" className="w-md">
                                        Update After Purchase Preferences
                                      </Button>
                                    </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>

                        {/* Purchase Agreements Section */}
                        <Row className="border-bottom">
                          <Col>
                            <Card className="mb-4">
                              <CardBody>
                                <h5 className="mb-3 font-size-16 text-dark fw-medium">Purchase Agreements</h5>
                                <p className="text-muted mb-4" style={{fontSize: '0.875rem'}}>
                                  Upload purchase agreement documents that customers must accept before checkout. 
                                  Mark documents as optional if acceptance is not required.
                                </p>

                                {/* Upload Section */}
                                <div className="mb-4 p-3 border rounded">
                                  <h6 className="mb-3">Upload New Agreement</h6>
                                  <Row>
                                    <Col md={6}>
                                      <div className="mb-3">
                                        <Label for="purchaseAgreementFile">Select Document (PDF, DOC, DOCX - Max 10MB)</Label>
                                        <Input
                                          type="file"
                                          id="purchaseAgreementFile"
                                          accept=".pdf,.doc,.docx"
                                          onChange={(e) => {
                                            const file = e.target.files?.[0];
                                            if (file) {
                                              setUploadFile(file);
                                            }
                                          }}
                                        />
                                        {uploadFile && (
                                          <small className="text-muted d-block mt-1">
                                            Selected: {uploadFile.name} ({(uploadFile.size / 1024 / 1024).toFixed(2)} MB)
                                          </small>
                                        )}
                                      </div>
                                    </Col>
                                    <Col md={6}>
                                      <div className="mb-3">
                                        <Label check className="d-flex align-items-center">
                                          <Input
                                            type="checkbox"
                                            checked={isOptional}
                                            onChange={(e) => setIsOptional(e.target.checked)}
                                            className="form-check-input me-2"
                                          />
                                          <span>Mark as optional (customers can skip acceptance)</span>
                                        </Label>
                                        <small className="text-muted d-block mt-1">
                                          If unchecked, customers must accept this agreement to proceed with checkout.
                                        </small>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Button 
                                    color="primary" 
                                    onClick={handleUploadAgreement}
                                    disabled={!uploadFile || isLoadingAgreements}
                                  >
                                    {isLoadingAgreements ? "Uploading..." : "Upload Agreement"}
                                  </Button>
                                </div>

                                {/* Agreements List */}
                                <div>
                                  <h6 className="mb-3">Existing Agreements</h6>
                                  {isLoadingAgreements && purchaseAgreements.length === 0 ? (
                                    <div className="text-center py-4">
                                      <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                      </div>
                                    </div>
                                  ) : purchaseAgreements.length === 0 ? (
                                    <div className="text-center py-4 text-muted">
                                      <p>No purchase agreements uploaded yet.</p>
                                    </div>
                                  ) : (
                                    <div className="table-responsive">
                                      <table className="table table-hover">
                                        <thead>
                                          <tr>
                                            <th>File Name</th>
                                            <th>Type</th>
                                            <th>Uploaded</th>
                                            <th>Actions</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {purchaseAgreements.map((agreement: any) => (
                                            <tr key={agreement.id}>
                                              <td>
                                                <i className="bx bx-file me-2"></i>
                                                {agreement.file_name}
                                              </td>
                                              <td>
                                                {agreement.optional ? (
                                                  <span className="badge bg-info">Optional</span>
                                                ) : (
                                                  <span className="badge bg-warning">Required <span className="text-danger">*</span></span>
                                                )}
                                              </td>
                                              <td>
                                                {agreement.created_at ? new Date(agreement.created_at).toLocaleDateString() : 'N/A'}
                                              </td>
                                              <td>
                                                <div className="d-flex gap-2">
                                                  {agreement.view_url && (
                                                    <>
                                                      <Button
                                                        color="info"
                                                        size="sm"
                                                        onClick={() => window.open(agreement.view_url, '_blank')}
                                                      >
                                                        <i className="bx bx-show me-1"></i>View
                                                      </Button>
                                                      <Button
                                                        color="secondary"
                                                        size="sm"
                                                        onClick={() => {
                                                          const link = document.createElement('a');
                                                          link.href = agreement.view_url;
                                                          link.download = agreement.file_name;
                                                          link.click();
                                                        }}
                                                      >
                                                        <i className="bx bx-download me-1"></i>Download
                                                      </Button>
                                                    </>
                                                  )}
                                                  <Button
                                                    color="danger"
                                                    size="sm"
                                                    onClick={() => handleDeleteAgreement(agreement.id)}
                                                    disabled={isLoadingAgreements}
                                                  >
                                                    <i className="bx bx-trash me-1"></i>Delete
                                                  </Button>
                                                </div>
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  )}
                                </div>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>

                        {/* Two-factor authentication section - hidden for now */}
                        {/* <Row className="border-bottom">
                          <Col>
                            <p className="mb-3 font-size-16 text-dark fw-medium">Two-factor authentication</p>
                            {!is_two_fact_status && step !== 1 && step !== 4  &&(
                              <div className="mb-3">
                                <p className="mb-1">Two-factor authentication is disable</p>
                                <p>For enhanced security, please enable two-factor authentication (2FA) using an authenticator app such as Microsoft Authenticator or Google Authenticator.</p>
                                <button className="btn btn-primary btn-sm" type="button" onClick={toggletwofactauth}>Enable Two Factor</button>
                              </div>
                            )}

                            {is_two_fact_status && step !== 2 && step !==3 &&(
                              <div className="mb-3">
                                <p>Two-factor authentication is enabled.</p>
                                <button className="btn btn-primary btn-sm" type="button" onClick={() => setStep(3)}>Disable Two-Factor Authentication</button>
                              </div>
                            )}

                            { step === 3 &&(
                              <Col md={6}>
                                <Label htmlFor="disableotp">Enter the code from your authenticator app to disable Two-Factor Authentication, or use your recovery code if you no longer have access to the app.<span className="text-danger px-1">*</span></Label>
                                <Input
                                  type="text"
                                  id="disableotp"
                                  name="disableotp"
                                  value={disableotp}
                                  onChange={disableotpchnage}
                                  placeholder="Enter 6-digit code"
                                  maxLength={6}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                                <button className="btn btn-primary btn-sm mt-2 mb-2" type="button" onClick={verify_disable_otp}>Continue</button>
                              </Col>
                            )}
                            {secretkey &&(
                              <div className="mb-3">
                                <p>Enable Two-Factor Authentication by scanning the QR code with an authenticator app such as Google Authenticator or Microsoft Authenticator to generate secure one-time passcodes.</p>
                                <p>Your Secret Key is : <strong>{secretkey}</strong></p>
                              </div>
                            )}

                            {step === 1 &&(
                              <div className="mb-3">
                                <img src={`data:image/png;base64,${qrImage}`}
                                  alt="QR Code" className="border" style={{ width: "200px", height: "200px" }} 
                                />
                                <p>If you can't scan the QR code, enter the secret key manually in your authenticator app to generate secure one-time passcodes.</p>
                              </div>
                            )}

                            {step === 1 &&(
                              <div className="mb-3">
                                <Label htmlFor="otp">Enter the code from your authenticator app<span className="text-danger px-1">*</span></Label>
                                <Input
                                  type="text"
                                  id="otp"
                                  name="otp"
                                  value={otp}
                                  onChange={handleotpchnage}
                                  placeholder="Enter 6-digit code"
                                  maxLength={6}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                                <div className="d-flex gap-1 align-items-center">
                                  <button className="btn btn-primary btn-sm" type="button" onClick={verify_two_fact}>Continue</button>
                                </div>
                              </div>
                            )}
                          </Col>

                          {step === 2 &&(
                            <div className="mb-3">
                              <h3>Save Your Recovery Codes</h3>
                              <ul className="ps-0">
                                {recoverykey.map((key, index) =>(
                                  <li className="mb-1" key={index}>{key}</li>
                                ))}
                              </ul>
                              <div className="d-flex align-items-center gap-1">
                                <button type="button" className="btn btn-primary btn-sm" onClick={() => {
                                  const content = recoverykey.join("\n");
                                  const blob = new Blob([content], {type : "text/plain"});
                                  const link = document.createElement('a');
                                  link.href = URL.createObjectURL(blob)
                                  link.download = "recovery-key.txt";
                                  link.click()
                                }}>Download Recovery Codes</button>
                                <button className="btn btn-secondary btn-sm" type="button" onClick={() => setmodal_center(true)}>Next</button>
                              </div>
                            </div>
                          )}

                          <Modal
                            isOpen={modal_center}
                            centered
                            className="rounded-4">
                            <ModalHeader className="py-3 px-4">
                              <div className="modal-title mt-0 font-size-16 text-dark">
                                Two-Factor Authentication Enabled
                              </div>
                            </ModalHeader>
                            <div className="p-6">
                              <Row>
                                <p>Your account is now protected with two-factor authentication.The setup is complete, and your login is more secure.</p>
                                <div className="d-flex justify-content-start">
                                  <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>Done</button>
                                </div>
                              </Row>
                            </div>
                          </Modal>
                        </Row> */}
                      </Form>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PrtProfile;
